import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSDM18MVRInstall extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 300">
                <path
                    d="M272.5,0H27.5A27.53,27.53,0,0,0,0,27.5v245A27.53,27.53,0,0,0,27.5,300h245A27.53,27.53,0,0,0,300,272.5V27.5A27.53,27.53,0,0,0,272.5,0ZM285,272.5A12.51,12.51,0,0,1,272.5,285H27.5A12.51,12.51,0,0,1,15,272.5V27.5A12.51,12.51,0,0,1,27.5,15h245A12.51,12.51,0,0,1,285,27.5Z"
                    fill={color}
                />
                <path d="M88.5,71A29.5,29.5,0,1,0,41.83,95v20h15V85.32a14.5,14.5,0,1,1,4.33,0V115h15V95A29.48,29.48,0,0,0,88.5,71Z" fill={color} />
                <path
                    d="M257.42,221A24.7,24.7,0,0,0,238,230.42a24.69,24.69,0,0,0-38.8,0,24.69,24.69,0,0,0-38.8,0,24.69,24.69,0,0,0-38.8,0,24.74,24.74,0,1,0,0,30.66,24.7,24.7,0,0,0,38.8,0,24.7,24.7,0,0,0,38.8,0,24.7,24.7,0,0,0,38.8,0A24.73,24.73,0,1,0,257.42,221ZM102.21,255.48a9.74,9.74,0,1,1,9.74-9.74A9.75,9.75,0,0,1,102.21,255.48Zm38.79,0a9.74,9.74,0,1,1,9.74-9.74A9.75,9.75,0,0,1,141,255.48Zm38.81,0a9.74,9.74,0,1,1,9.74-9.74A9.75,9.75,0,0,1,179.82,255.48Zm38.79,0a9.74,9.74,0,1,1,9.74-9.74A9.75,9.75,0,0,1,218.61,255.48Zm38.81,0a9.74,9.74,0,1,1,9.74-9.74A9.75,9.75,0,0,1,257.42,255.48Z"
                    fill={color}
                />
            </svg>
        );
    }
}

export default withTheme(SvgSDM18MVRInstall);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSDM18MVRInstall.js